<div class="sort-toggle">
    @for (item of buttonTabs; let i = $index; track item) {
        <div class="sort-toggle-buttons" (click)="onTabClick($event, item.id)">
            <div class="sort-toggle-button" [class.active]="item.active">
                {{ item.title }}
            </div>
        </div>
    }
</div>
